var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { AnalyticsService } from './analytics.service';
import { Angulartics2 } from 'angulartics2';
var BrowserAnalyticsService = /** @class */ (function (_super) {
    __extends(BrowserAnalyticsService, _super);
    function BrowserAnalyticsService(angulartics2GoogleTagManager, angulartics2) {
        var _this = _super.call(this) || this;
        _this.angulartics2 = angulartics2;
        return _this;
        //Must inject component to activate gtm
    }
    BrowserAnalyticsService.prototype.eventTrack = function (tagName, extras) {
        this.angulartics2.eventTrack.next({
            properties: {
                event: tagName,
                gtmCustom: extras ? extras : undefined
            }
        });
    };
    return BrowserAnalyticsService;
}(AnalyticsService));
export { BrowserAnalyticsService };
